import {useMutation} from '@apollo/react-hooks';

import type {
    CreateActivityType as CreateActivityTypeMutation,
    CreateActivityTypeVariables as CreateActivityTypeMutationVariables,
    ActivityTypeCreateInput,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_TYPES from '../../../../core/select/queries/get-activity-types.graphql';

import CREATE_ACTIVITY_TYPE from '../mutations/create-activity-type.graphql';

export function useCreateActivityType(): {
    createActivityType: (arg1: ActivityTypeCreateInput) => Promise<any>;
    isCreating: boolean;
} {
    const [createActivityType, {loading}] = useMutation<
        CreateActivityTypeMutation,
        CreateActivityTypeMutationVariables
    >(CREATE_ACTIVITY_TYPE);

    return {
        createActivityType: (input: ActivityTypeCreateInput) =>
            createActivityType({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const newActivityType =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.activityTypeCreate &&
                        mutationResults.data.activityTypeCreate.activityType;

                    const cacheResult = proxy.readQuery({
                        query: GET_ACTIVITY_TYPES,
                    });

                    if (cacheResult && newActivityType) {
                        proxy.writeQuery({
                            query: GET_ACTIVITY_TYPES,
                            data: {
                                // @ts-expect-error
                                activityTypes: [...cacheResult.activityTypes, newActivityType],
                            },
                        });
                    }
                },
            }),
        isCreating: loading,
    };
}
